import { Icon } from '@chakra-ui/react';

export const Completed = (props) => (
  <Icon viewBox="0 0 16 16" boxSize="16px" color="icon.g1" {...props}>
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" fill="transparent" />
    <path d="M10.6921 6.10262L6.59543 9.81128L5.08622 8.25872" stroke="currentColor" strokeWidth="2" />
  </Icon>
);
